import type { ButtonHTMLAttributes, ReactNode } from "react";

type Variant = "primary-dark" | "light-on-dark" | "ghost-on-dark";

const variantMap: Record<Variant, string> = {
  "primary-dark": "bg-ink-900 text-on-dark-bright hover:bg-ink-850",
  "light-on-dark": "bg-on-dark-bright text-ink-900 hover:bg-white",
  "ghost-on-dark":
    "border border-[rgba(233,242,238,0.3)] text-on-dark-bright hover:border-[rgba(233,242,238,0.6)]",
};

export function Button({
  variant = "primary-dark",
  children,
  className = "",
  ...rest
}: ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: Variant;
  children: ReactNode;
}) {
  return (
    <button
      className={`inline-flex items-center gap-2 rounded-md px-3 py-1.5 text-xs font-semibold disabled:opacity-60 ${variantMap[variant]} ${className}`}
      {...rest}
    >
      {children}
    </button>
  );
}
